import { ServiceTeamId } from "@fartherfinance/frontend/api/Types";

export const onboardingServiceTeam = {
  UAT: {
    label: "Onboarding",
    value: "0a93d60b-25c8-431d-854c-7004fdb7cd7c" as ServiceTeamId,
  },
  PROD: {
    label: "Onboarding",
    value: "b1180862-033d-4709-aafd-f40f5351f824" as ServiceTeamId,
  },
};

export const complianceServiceTeam = {
  UAT: {
    label: "Compliance",
    value: "e4c87f48-9ec7-49c4-ba02-933d78a6ccf4" as ServiceTeamId,
  },
  PROD: {
    label: "Compliance",
    value: "6b6bb98d-4be0-4be0-accc-b4d65eb81942" as ServiceTeamId,
  },
};

export const itServiceTeam = {
  UAT: {
    label: "IT",
    value: "1936cb82-3bb9-4e30-8331-56e024ff5cfd" as ServiceTeamId,
  },
  PROD: {
    label: "IT",
    value: "a905cca7-77b4-41f9-ab61-6df724554183" as ServiceTeamId,
  },
};

export const businessOperationsServiceTeam = {
  UAT: {
    label: "Business Operations",
    value: "a0927833-ba06-4197-bfd1-c2e5c4ea8c5e" as ServiceTeamId,
  },
  PROD: {
    label: "Business Operations",
    value: "57287b82-a543-4ebd-8231-64f44047c3d8" as ServiceTeamId,
  },
};

export const transitionsServiceTeam = {
  UAT: {
    label: "Transitions",
    value: "7c4e3db2-923f-4991-93c9-e46951bc7eb0" as ServiceTeamId,
  },
  PROD: {
    label: "Transitions",
    value: "6ed33526-d9c9-4f69-a30d-d09de620ce06" as ServiceTeamId,
  },
};

export const advisorSuccessServiceTeam = {
  UAT: {
    label: "Advisor Success",
    value: "44b20aa7-7ef1-46e6-a6aa-1b6b9fc95cc6" as ServiceTeamId,
  },
  PROD: {
    label: "Advisor Success",
    value: "8f00f605-ff78-4c6c-8999-209cdba6317b" as ServiceTeamId,
  },
};

export const hrServiceTeam = {
  UAT: {
    label: "HR",
    value: "3a2d9e2d-1216-4a7b-9704-930eb827b845" as ServiceTeamId,
  },
  PROD: {
    label: "HR",
    value: null,
  },
};
